import React, { useEffect } from "react";

export default function TypeformEmbed({ formId }) {
  useEffect(() => {
    const existingScript = document.querySelector(
      'script[src="https://embed.typeform.com/next/embed.js"]'
    );

    if (!existingScript) {
      const script = document.createElement("script");
      script.src = "https://embed.typeform.com/next/embed.js";
      script.async = true;
      document.body.appendChild(script);
    } else if (window.tf?.load) {
      window.tf.load();
    }
  }, [formId]);

  return <div data-tf-live={formId}></div>;
}